/* eslint-disable @typescript-eslint/no-var-requires */
const packageMeta = require('./package.json');
const seamlessRc = require('./../../.seamlessrc.json');

const NAME = 'region-picker';
const TENANT = seamlessRc.tenantId;
const pluginPath = `/${TENANT}-${NAME}/${TENANT}-${NAME}-${packageMeta.version}`;

const marketAvailability = [
  {
    language: 'en',
    country: 'AU',
  },
  {
    language: 'en',
    country: 'IN',
  },
  {
    language: 'de',
    country: 'AQ',
  },
  {
    language: 'en',
    country: 'AQ',
  },
];

module.exports = {
  manifestVersion: '2.0',
  name: `${TENANT}-${NAME}`,
  version: packageMeta.version,
  config: {
    hasCss: false,
    files: {
      scripts: [
        {
          url: `${pluginPath}/js/vendor.js`,
          attrs: {
            type: 'module', // vendor
          },
        },
        {
          url: `${pluginPath}/js/app.js`,
          attrs: {
            type: 'module', // component
          },
        },
      ],
    },
    dependencies: {
      oneweb: '2.0',
    },
    isUserSessionRequired: false,
    integrationType: 'webcomponent',
    marketAvailability: marketAvailability,
  },
  //https://confluence.mercedes-benz.io/display/COMPONENTS/Seamless+Integrator+-+Dialog+Generator
  aemComponentConfig: {
    title: 'Region-picker Web Component',
    description: packageMeta.description,
    componentGroup: '.hidden',
    productPrefix: seamlessRc.prefix,
    tagNameWithoutPrefix: 'region-picker',
    globalComponent: true,
    dialog: [
      {
        widgetType: 'checkbox',
        param: 'isOpenOnStart',
        defaultValue: false,
        label: 'Open the region picker when user enters the page',
      },
      {
        widgetType: 'checkbox',
        param: 'isRequired',
        defaultValue: false,
        label: 'If true, the user needs to enter a valid region. Otherwise the region picker can not be closed.',
      },
    ],
  },
};
